import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Button,
  ListGroup,
  ListGroupItem,
  // NavbarToggler,
  Nav, Navbar, NavItem, NavLink,
  Popover, PopoverBody,
  Card, CardTitle, CardSubtitle, CardBody
} from 'reactstrap';
import {
    MdClearAll,
    MdExitToApp,
    MdNotificationsNone,
    MdNotificationsActive,
    MdSettingsApplications,
    MdSettingsBackupRestore
} from 'react-icons/md';
import {Link} from "react-router-dom";
import LoginPageCustomer from "./LoginPageCustomer";

import HeaderNotiAdminComponent from '../Admin/noti_admins/HeaderNotiAdminComponent';
import withBadge from '../../hocs/withBadge';

const MdNotificationsActiveWithBadge = withBadge(
  {
    size: 'md',
    color: 'primary',
    style: {
      top: -10,
      right: -10,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    // children: <small>5</small>,
  }
)(MdNotificationsActive);

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpenNotificationPopover: false,
      isNotificationConfirmed: false,
      isOpenUserCardPopover: false,
    };
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.getUnReadNotiAdmins();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ 
        isOpenUserCardPopover: false,
        isOpenNotificationPopover: false,
      });
    }
  }

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
  
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };
  
  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });
  
    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  getUnReadNotiAdmins = () => {
    let dataAuth = {
      username: process.env.REACT_APP_CLIENT_ID,
      password: process.env.REACT_APP_CLIENT_PASSWD,
      token: process.env.REACT_APP_KEY,
    };

    let config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : this.props.token,
        'dataAgency' : JSON.stringify(dataAuth)
      }
    }

    axios.get(process.env.REACT_APP_API_URL + '/api/admin/noti-admin/get-unread-noti-admin', config )
    .then((ref) => {
        if (ref.data.error === 0) {
            this.updateNotiAdmin(ref.data)
        } else {
            if (ref.data.error > 9000) {
                this.props.logOut();
            } else {
                this.setState({
                    error: true,
                    messageError: ref.data.message
                })
            }
        }
    })
    .catch((error) => {
        console.log(error);
        this.setState({
            error: true,
            messageError: 'Lấy dữ liệu thông báo thất bại',
        })
    })
  }

  updateNotiAdmin = (data) => {
      let itemNotiAdmin = {
          noti_admins: data.noti_admins,
          unread_noti_admin: data.unread_noti_admin
      }
      this.props.updateNotiAdmin(itemNotiAdmin);
  }

  logOut = async () => {
      let dataAuth = {
          username: process.env.REACT_APP_CLIENT_ID,
          password: process.env.REACT_APP_CLIENT_PASSWD,
          token: process.env.REACT_APP_KEY,
      };

      let config = {
          headers: {
              'Content-Type': 'application/json',
              'Authorization' : this.props.token,
              'dataAgency' : JSON.stringify(dataAuth)
          }
      }
      await axios.get(process.env.REACT_APP_API_URL + '/api/logOut', config );
      await this.props.logOut();
  }

  render() {
    return (
      <Navbar light expand className="cr-header bg-white navbar navbar-expand navbar-light">
        <Nav navbar className="mr-2">
          <Button outline onClick={this.handleSidebarControlButton}>
            <MdClearAll size={25} />
          </Button>
        </Nav>
        <Nav navbar>
        </Nav>

        <Nav navbar className="cr-header__nav-right navbar-nav">

          <NavItem className="d-inline-flex">
            <NavLink id="Popover1" className="position-relative">
              {this.props.unread_noti_admin === 0 ? (
                <MdNotificationsNone
                  size={25}
                  className="text-secondary can-click"
                  onClick={this.toggleNotificationPopover}
                />
              ) : (
                <MdNotificationsActiveWithBadge
                  size={25}
                  className="text-secondary can-click animated swing infinite"
                  onClick={this.toggleNotificationPopover}
                  unread_notification = {this.props.unread_noti_admin}
                />
              )}
            </NavLink>
            <Popover
              placement="bottom"
              isOpen={this.state.isOpenNotificationPopover}
              toggle={this.toggleNotificationPopover}
              target="Popover1"
              innerRef={this.wrapperRef}
            >
              <PopoverBody>
                <HeaderNotiAdminComponent />
              </PopoverBody>
            </Popover>
          </NavItem>

          <NavItem>
            <NavLink innerRef={this.wrapperRef} id="Popover2">
              <img src={ this.props.user.avatar } alt='avatar' onClick={this.toggleUserCardPopover} className="rounded-circle can-click nav-avatar" />
            </NavLink>
            <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover}
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 250 }}
              innerRef={this.wrapperRef}
            >
              <PopoverBody className="p-0 border-light">
                <Card inverse className="bg-gradient-theme border-light">
                  <CardBody className="d-flex justify-content-center align-items-center flex-column">
                    <img src={ this.props.user.avatar } alt='avatar' onClick={this.toggleUserCardPopover} className="rounded-circle can-click mb-2 nav-avatar-detail" />
                    <CardTitle className="mb-2">{ this.props.user.name }</CardTitle>
                    <CardSubtitle>Role: { this.props.user.role }</CardSubtitle>
                    <CardSubtitle>{ this.props.user.email }</CardSubtitle>
                  </CardBody>
                  <ListGroup flush>
                      <LoginPageCustomer />
                    <Link to={'admin/config-system'}>
                      <ListGroupItem tag="button" action className="border-light">
                        <MdSettingsApplications /> Cài đặt chung
                      </ListGroupItem>
                    </Link>
                    <Link to={'admin/activity-log'}>
                      <ListGroupItem tag="button" action className="border-light">
                        <MdSettingsBackupRestore /> Quản lý hoạt động
                      </ListGroupItem>
                    </Link>
                    <ListGroupItem tag="button" action className="border-light"  onClick={ () => this.logOut() }>
                      <MdExitToApp /> Đăng xuất
                    </ListGroupItem>
                  </ListGroup>
                </Card>
              </PopoverBody>
            </Popover>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.login.token,
    user: state.user.user,
    sessionRole: state.user.sessionRole,
    noti_admins: state.agency.noti_admins,
    unread_noti_admin: state.agency.unread_noti_admin,
  }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut' , page: 'AdminHeader'}))
        },
        updatePage: (item) => {
            dispatch(({ type : 'updatePage', item }))
        },
        updatePageAdmin: (item) => {
            dispatch(({ type : 'updatePageAdmin', item }))
        },
        updateNotiAdmin: (item) => {
            dispatch(({type: 'updateNotiAdmin', item}))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);